<template>
  <div class="box-purchase">
    <div class="box-center">
      <el-collapse v-model="activeNames">
        <template v-for="(item,index) in applyList">
          <el-collapse-item :title="item.create_time" :name="index+''" :key="'purchase' + index">
            <template slot="title">
              <div class="hs-collapse-item-header">
                <div class="title">
                  <span class="mr8"> <i class="el-icon-d-caret"></i>{{item.create_time}}</span>
                  <el-tag type="danger" v-if="item.work_status==1">派单中</el-tag>
                </div>
                <div class="remind">
                  <div class="remind-item">
                    <el-button @click.stop="excelFile(item)">导出</el-button>
                    <el-button v-if="item.item_check_status1==-1" type="primary" plain @click.stop="showDrawerPass(_self, 'confirmView', 'showProcess', [item,'purchase_background',wedding])" size="mini">沟通</el-button>
                    <el-button v-else type="primary" plain @click.stop="showDrawerPass(_self, 'confirmView', 'showDrawer', [item.id,'other','purchase'])" size="mini">{{getItemCheckTitle(item.item_check_status1)}}</el-button>
                    <!-- <el-button type="primary" v-if="item.item_check_status1==2" @click.stop="showDrawerPass(_self, 'applicationPurchase', 'showDrawer', [item,'edit'])">临时编辑</el-button> -->
                    <el-button type="primary" v-if="item.item_check_status1==-1||item.item_check_status1==3" @click.stop="showDrawerPass(_self, 'applicationPurchase', 'showDrawer', [item,'edit'])">
                      派单</el-button>
                    <template v-has="[137]"  v-if="item.item_check_status1==2">

                      <el-button type="primary" plain v-if="item.edit_check_status>-1" @click.stop="showDrawerPass(_self, 'confirmView', 'showDrawer', [item.id,'other','demand_tmp_edit'])" size="mini">临时－{{getItemCheckTitle(item.edit_check_status)}}</el-button>
                      <el-button type="primary" v-if="item.edit_check_status ==-1" @click.stop="showDrawerPass(_self, 'applicationPurchase', 'showDrawer', [item,'editors'])">临时修改</el-button>
                      <el-button type="primary" v-if="item.edit_check_status==3" @click.stop="showDrawerPass(_self, 'applicationPurchase', 'showDrawer', [item,'editors'])">临时-驳回编辑</el-button>
                    </template>
                  </div>
                </div>
              </div>
            </template>
            <el-table :data="item.addons" border show-summary>
              <el-table-column type=index label="序号" width="50"></el-table-column>
              <el-table-column prop="title" label="物品名称"></el-table-column>
              <el-table-column prop="spec" label="规格"></el-table-column>
              <el-table-column prop="amount" label="数量"></el-table-column>
              <el-table-column prop="price" label="单价"></el-table-column>
              <el-table-column prop="real_total" label="实际总价"></el-table-column>
              <el-table-column prop="total" label="总价"></el-table-column>
              <el-table-column label="供应商">
                <template slot-scope="scope" v-if="scope.row.supplier">
                  <span class="text-color1"> {{scope.row.supplier.title}}</span>
                </template>
              </el-table-column>
              <el-table-column label="物料">
                <template slot-scope="scope" v-if="scope.row.product">
                  <span class="text-color1"> {{scope.row.product.title}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="freight" label="运费"></el-table-column>
              <el-table-column prop="send_time" label="发货时间"></el-table-column>
              <el-table-column prop="url" label="购买链接" show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-link type="primary" :href="scope.row.url" target="_blank" class="mr8">
                    {{scope.row.url}}</el-link>
                </template>
              </el-table-column>
              <el-table-column prop="image" label="图片">
                <template slot-scope="scope">
                  <template v-for="(e, i) in scope.row.imagesListNew">
                    <el-image style="width: 50px; height: 50px" :src="e.url" :preview-src-list="e.srcList" :key="i">
                    </el-image>
                  </template>
                </template>
              </el-table-column>
              <el-table-column label="结算">
                <template slot-scope="scope">
                  <template v-if="scope.row.settle==1">结算中</template>
                  <template v-if="scope.row.settle==2">结算通过</template>
                  <template v-if="scope.row.settle==3">结算驳回</template>
                  <template v-if="!scope.row.settle">待结算</template>
                </template>
              </el-table-column>
              <el-table-column label="是否作废">
                <template slot-scope="scope">
                  <template v-if="scope.row.invalid_id=='0'">已作废</template>
                  <template v-if="scope.row.invalid_id=='1'">未作废</template>
                </template>
              </el-table-column>
              <el-table-column prop="remark" label="备注"></el-table-column>
            </el-table>
          </el-collapse-item>
        </template>
      </el-collapse>
      <application-purchase ref="applicationPurchase" @getData="getData" :parent="_self"></application-purchase>
    </div>
    <confirm-view ref="confirmView"></confirm-view>
  </div>
</template>

<script>
import {
  showDrawerPass,
  getItemCheckTitle
} from '@/utils/common.js';
import {
  has
} from '@/utils/promissions';
import applicationPurchase from '../../allocate/apply.vue';
import commentView from '@/components/comment/comment.vue';
import confirmView from '@/components/audit/confirm.vue';
export default {
  props: {
    parent: {}
  },
  components: {
    applicationPurchase,
    commentView,
    confirmView
  },
  data() {
    return {
      order_id: 0,
      applyList: [],
      activeName: "product",
      module: 'wedding_design',
      module_id: 0,
      activeNames: ['0'],
      wedding: {}
    }
  },
  beforeCreate() {
    this.showDrawerPass = showDrawerPass;
    this.getItemCheckTitle = getItemCheckTitle;
  },
  methods: {
    getData(order_id) {
      let _this = this;
      let url = '/api/plan.demand/read';
      this.order_id = order_id;
      this.$post(url, {
        order_id: order_id,
        type: "purchase",
      }).then(res => {
        _this.applyList = res.data.demands;
        _this.wedding = res.data.wedding
        _this.$set(_this.applyList, res.data.demands);
        _this.$forceUpdate();
      })
    },
    getDataTable() {
      this.getData(this.order_id);
      this.$forceUpdate();

    },
    showDetail(id) {
      let _this = this;
      if (_this.$refs['confirmView']) {
        _this.$refs['confirmView'].showDrawer(id, 'plan', 'purchase');
      } else {
        _this.$nextTick(function () {
          _this.$refs['confirmView'].showDrawer(id, 'plan', 'purchase');
        })
      }
    },
    excelFile(row) {
      let _this = this;
      let url = '/api/statistics.supplier/exportOrderBom';
      let options = {};
      options.order_id = row.order_id,
        this.$post(url, options).then(res => {
          if (res.code == '200') {
            let link = document.createElement('a');
            link.href = res.data.url;
            link.click();

          }
        })

    },
  }
}
</script>

<style lang="less" scoped>
@import url('@/assets/css/common.less');

.box-purchase {
    display: flex;

    .box-center {
        flex: 1;
        padding: 12px;
    }

    .box-comment {
        flex: 0 25%;
        border-left: 1px solid #dedede;
        padding: 12px;
    }

    .img {
        width: 100px;
        height: 100px;
        margin-right: 10px;
    }

    .apply-list {
        padding: 5px 0;
        display: block;
    }

    .title-purchase {
        margin: 10px 0;
    }
}
</style>